<template>
  <div class="dropdown">
    <a 
      v-on:click="openDropDown"
      class="dropdown--button"      
    >      
      {{ title }}
      <ChevronDownIcon/>
    </a>

    <div class="dropdown--list drop-shadow">
      <slot/>
    </div>
  </div>  
</template>

<script>
  import ChevronDownIcon from '../../icons/chevronDown.vue'  

  export default {
    name: 'Dropdown',
    props: [
      'title'
    ],
    components: {
      ChevronDownIcon
    },
    methods: {
      openDropDown: function() {
        let ulEl = this.$el.querySelector('.dropdown--list');
        let isCurrentDropdownShown = ulEl.classList.contains('dropdown--show');
        let dropdowns = document.getElementsByClassName('dropdown--list');

        let dropdownButtons = document.getElementsByClassName('dropdown--button');

        for (let i = 0; i < dropdowns.length; i++) {
          dropdowns[i].classList.remove('dropdown--show');
          dropdownButtons[i].classList.remove('dropdown--button-active');
        }

        if (!isCurrentDropdownShown){
          let dropdownButton = this.$el.querySelector('.dropdown--button');
          dropdownButton.classList.add('dropdown--button-active');

          ulEl.classList.add('dropdown--show');
        }
      }
    }
  }
</script>

<style lang="scss">
  .dropdown {
    position: relative;

    &--button {
      display: block;
      height: 30px;
      background-color: var(--white);
      border: 1px solid var(--blue-medium);
      padding: 4px 6px;
      cursor: pointer;
      color: var(--blue);
      transition: 0.2s;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;

      .chevron-down {
        position: absolute;
        right: 6px;
        top: 12px;
      }
    }

    &--button:hover,
    &--button-active {
      background-color: var(--blue);
      border: 1px solid var(--blue);
      color: var(--white);

      .chevron-down {
        path {
          fill: var(--white);
        }
      }
    }

    &--list {
      position: relative;
      background-color: var(--white);
      margin-top: 0;
      padding-bottom: 5px;
      opacity: 0;
      visibility: hidden;
      transition: 0.2s;
      position: absolute;
      width: 100%;
      z-index: 1;
    }

    &--show {
      opacity: 1;
      visibility: visible;
      margin-top: 5px;
    }

    &--content--list--click {
      color: black !important;
    }
  } 
</style>